import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { GameLogic } from "../../../Logic/GameLogic";
import { GameModel } from "../../../Models/GameModel";

export interface IUICoinsControllerOptions {
    onClick():void;
}

export class UICoinsController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: IUICoinsControllerOptions,
        @Inject private _gameLogic: GameLogic,
        ) {
        super('UICoinsController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {

            },
            modelWatch: {
                userBalanceCoins: () =>  {
                   this.setText();
                },
            },
        }
    }

    protected onInitialize() {
        if (this._options.onClick) {
            this.display.interactive = true;
            this.display.buttonMode = true;
            this.display.on('pointerup', () => {
                this._options.onClick();
            });
        }
        this.setText();
    }

    private setText() {
        const txt = this.getDisplayObjectByQuery('txt')[0] as PIXI.Text;
        txt.text = this.$model.userBalanceCoins.toFixed();
    }

}
